"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var Preact = __importStar(require("preact"));
var function_1 = require("fp-ts/lib/function");
var O = __importStar(require("fp-ts/Option"));
var Arr = __importStar(require("fp-ts/Array"));
var isHtmlInput = function (e) { return e != null && e.files !== undefined; };
/** An icon button which accepts a File as input */
var Component = function (p) {
    return (Preact.h(IconButton_1.default, { disabled: p.disabled, component: "label", size: "small", sx: __assign({}, p.sx) },
        Preact.h("input", { type: "file", hidden: true, accept: p.accept.join(' '), disabled: p.disabled, onChange: function (e) {
                (0, function_1.pipe)(e.target, O.fromNullable, O.filter(isHtmlInput), O.chain(function (input) { return (0, function_1.pipe)(input.files, O.fromNullable); }), O.chain(function (files) { return (0, function_1.pipe)(Array.from(files), Arr.head); }), O.map(function (file) {
                    p.onChange(file);
                }));
            } }),
        p.icon));
};
exports.Component = Component;
